"use client";

import { c as _c } from "react/compiler-runtime";
import type { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import React from "react";
interface WaveleaderboardSortProps {
  readonly sort: WaveDropsLeaderboardSort;
  readonly onSortChange: (sort: WaveDropsLeaderboardSort) => void;
  readonly mode?: WaveleaderboardSortMode;
  readonly items?: readonly CommonSelectItem<WaveDropsLeaderboardSort>[] | undefined;
}
type WaveleaderboardSortMode = "tabs" | "dropdown";
export const WAVE_LEADERBOARD_SORT_ITEMS: readonly CommonSelectItem<WaveDropsLeaderboardSort>[] = [{
  key: WaveDropsLeaderboardSort.RANK,
  label: "Current Vote",
  value: WaveDropsLeaderboardSort.RANK
}, {
  key: WaveDropsLeaderboardSort.RATING_PREDICTION,
  label: "Projected Vote",
  value: WaveDropsLeaderboardSort.RATING_PREDICTION
}, {
  key: WaveDropsLeaderboardSort.TREND,
  label: "Hot",
  value: WaveDropsLeaderboardSort.TREND
}, {
  key: WaveDropsLeaderboardSort.CREATED_AT,
  label: "Newest",
  value: WaveDropsLeaderboardSort.CREATED_AT
}];
export const WAVE_LEADERBOARD_CURATION_SORT_ITEMS: readonly CommonSelectItem<WaveDropsLeaderboardSort>[] = [...WAVE_LEADERBOARD_SORT_ITEMS, {
  key: WaveDropsLeaderboardSort.PRICE,
  label: "Price",
  value: WaveDropsLeaderboardSort.PRICE
}];
export const WaveleaderboardSort: React.FC<WaveleaderboardSortProps> = t0 => {
  const $ = _c(17);
  const {
    sort,
    onSortChange,
    mode: t1,
    items: t2
  } = t0;
  const mode = t1 === undefined ? "dropdown" : t1;
  const items = t2 === undefined ? WAVE_LEADERBOARD_SORT_ITEMS : t2;
  let t3;
  if ($[0] !== sort) {
    t3 = value => {
      if (sort === value) {
        return "tw-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-leading-5 tw-transition-all tw-duration-300 tw-ease-out tw-bg-iron-800 tw-text-iron-100";
      }
      return "tw-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-leading-5 tw-transition-all tw-duration-300 tw-ease-out tw-bg-iron-950 tw-text-iron-500 hover:tw-bg-iron-900 hover:tw-text-iron-100";
    };
    $[0] = sort;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const getTabClassName = t3;
  if (mode === "tabs") {
    let t4;
    if ($[2] !== getTabClassName || $[3] !== items || $[4] !== onSortChange || $[5] !== sort) {
      let t5;
      if ($[7] !== getTabClassName || $[8] !== onSortChange || $[9] !== sort) {
        t5 = item => <button key={item.key} type="button" role="tab" aria-label={item.label} aria-selected={sort === item.value} tabIndex={sort === item.value ? 0 : -1} className={getTabClassName(item.value)} onClick={() => onSortChange(item.value)}>{item.label}</button>;
        $[7] = getTabClassName;
        $[8] = onSortChange;
        $[9] = sort;
        $[10] = t5;
      } else {
        t5 = $[10];
      }
      t4 = items.map(t5);
      $[2] = getTabClassName;
      $[3] = items;
      $[4] = onSortChange;
      $[5] = sort;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[11] !== t4) {
      t5 = <div role="tablist" aria-label="Sort options" className="tw-flex tw-items-center tw-gap-x-1 tw-rounded-lg tw-bg-iron-950 tw-p-1 tw-ring-1 tw-ring-inset tw-ring-iron-800">{t4}</div>;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t4;
  if ($[13] !== items || $[14] !== onSortChange || $[15] !== sort) {
    t4 = <div className="tw-min-w-0 tw-flex-shrink-0"><CommonDropdown items={items} activeItem={sort} filterLabel="Sort" setSelected={onSortChange} size="sm" showFilterLabel={true} /></div>;
    $[13] = items;
    $[14] = onSortChange;
    $[15] = sort;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};